import * as React from 'react';
import { SectionDynamic } from '../../uiComponents/layout/SectionDynamic';
import { DropDownFormGroup, MenuItemDto } from '../../uiComponents/input/FormGroups';
import { OpgavepakkeOpgave } from '../../models/OpgavepakkeOpgave';
import { Logbog } from '../../models/Logbog';
import { Row, Col } from '../../uiComponents/bootstrap-components/BootstrapComponents';
import { ValidationError } from '../../infrastructure/ValidationResult';

export interface OpgavepakkeOpgavePresenterProps {
    index: number;
    opgavepakkeOpgave: OpgavepakkeOpgave;
    logboeger: Logbog[];
    errorMessages: ValidationError[];
    onRemoveOpgave: (index: number) => void;
    onChange: (fieldName: string, value: any, index: number) => void;
}

class OpgavepakkeOpgavePresenter extends React.Component<OpgavepakkeOpgavePresenterProps, any> {

    render() {
        let synlighedItems: MenuItemDto[] = new Array();
        synlighedItems.push(new MenuItemDto(true, 'Synlig før konkurrencedag'));
        synlighedItems.push(new MenuItemDto(false, 'Først synlig på konkurrencedag'));

        let logbogDropDownItems = this.props.logboeger.map(l =>
            new MenuItemDto(l.id, l.titel)
        );    

        const opgaveDublet = this.props.errorMessages.find(e => e.field === 'opgaveDublet');

        return (
            <div id='opgavepakke'>
                <SectionDynamic index={this.props.index} deleteOnClick={() => this.props.onRemoveOpgave(this.props.index)}>
                    <Row>
                        <Col md={3}>
                            {/* billede */}
                        </Col>
                        <Col md={6}>
                            <h4>{this.props.opgavepakkeOpgave.opgavetitel}</h4>
                            <Row>
                                <Col md={6}>
                                    <DropDownFormGroup
                                        errorMessages={this.props.errorMessages}
                                        items={synlighedItems}
                                        name='synligFoerKonkurrenceStart'
                                        label=''
                                        selectedValue={this.props.opgavepakkeOpgave.synligFoerKonkurrenceStart}
                                        onChange={(fieldName: string, value: any) => this.props.onChange(fieldName, value, this.props.index)}
                                        ingenValgtText='Vælg synlighed'
                                    />
                                </Col>
                                <Col md={6}>
                                    <DropDownFormGroup
                                        errorMessages={this.props.errorMessages}
                                        items={logbogDropDownItems}
                                        name='logbogId'
                                        label=''
                                        selectedValue={this.props.opgavepakkeOpgave.logbogId === '00000000-0000-0000-0000-000000000000' ? undefined : this.props.opgavepakkeOpgave.logbogId}
                                        onChange={(fieldName: string, value: any) => this.props.onChange(fieldName, value, this.props.index)}
                                        ingenValgtText='Vælg logbog'
                                    />

                                </Col>                               
                            </Row>
                            {opgaveDublet !== undefined &&
                                <div className='error-message'>
                                    {opgaveDublet.error}
                                </div>
                            }
                        </Col>
                    </Row>
                </SectionDynamic>
            </div>

        );
    }
}

export default OpgavepakkeOpgavePresenter;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/opgavepakke/OpgavepakkeOpgavePresenter.tsx